// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MzRdD","nav":"Header_nav__xfKpH","logo":"Header_logo__XwyX+","login":"Header_login__rxlDC"};